import { CONTENT_BASE_URL } from "./constants";

/**
 * ブログ・ユーザーガイドへのリンク生成。
 *
 * これらは SPA ではなく apps/content(Astro + Starlight)が配信する。SPA にルートは無く、
 * 相対パスで踏むと App.tsx の catch-all（404 ページ）に落ちるため、
 * 必ずこのヘルパーで URL を組み立てる（オリジンの解決は CONTENT_BASE_URL が担う）。
 *
 * ⚠️ コンテンツ Worker が所有するパス（/blog*・/user-guide*・/ja/* 等）の正本は
 * apps/content/wrangler.jsonc の routes。セクションを増やすときは両方を更新する。
 * とくに /ja/* はまるごとコンテンツ Worker 所有なので、SPA 側のルートには使えない。
 */
/**
 * コンテンツ Worker が所有するパスプレフィックス。
 * apps/content/wrangler.jsonc の routes と 1:1 対応（正本はそちら）。
 * ズレは scripts/check-content-routes.mjs（pnpm check:content-routes）が CI で検知する。
 */
export const CONTENT_PATH_PREFIXES = [
  "/blog",
  "/changelog",
  "/user-guide",
  "/ja",
  "/sitemap",
  "/_astro",
  "/pagefind",
] as const;

type ContentSection = "blog" | "changelog" | "user-guide";

/**
 * コンテンツ側のルートは / = EN。JA UI からは /ja/ 配下へ誘導する。
 * 末尾スラッシュは必須(Astro の trailingSlash:'always' と canonical に一致。
 * 付けないと開発サーバーが 404、本番は 307 リダイレクトを一段挟む)。
 */
export function getContentHref(section: ContentSection, language: string): string {
  const languagePrefix = language === "ja" ? "/ja" : "";
  return `${CONTENT_BASE_URL}${languagePrefix}/${section}/`;
}

/**
 * 個別ブログ記事（サービス紹介記事を含む）へのリンク生成。
 * ロケール接頭辞と末尾スラッシュの規約は getContentHref に一本化し、slug を足すだけにする。
 */
export function getBlogPostHref(slug: string, language: string): string {
  return `${getContentHref("blog", language)}${slug}/`;
}
